import { type FC, type ReactNode, useId } from 'react'
import { Form, Stack } from 'react-bootstrap'
import { ScopedBlock } from '../../../../components/ScopedBlock/ScopedBlock'
import { MissingScopeAction } from '../../../../components/ScopedBlock/models'
import { getIntegrationDisplayName, type IntegrationServiceId } from '../../../../common/integrations'

const UPDATE_SCOPE = { scope: 'integration:update', superScope: ['integration:admin'] }

export interface CalendarAttendeeSourceOption {
  value: string
  label: string
  description: string
}

export interface CalendarAttendeeSourceConfig {
  value: string
  options: CalendarAttendeeSourceOption[]
  note?: ReactNode
}

export interface CalendarAttendeeSourceFieldProps {
  serviceId: IntegrationServiceId
  options: CalendarAttendeeSourceOption[]
  note?: ReactNode
  value: string | null
  disabled?: boolean
  onChange: (value: string) => void
}

export const CalendarAttendeeSourceField: FC<CalendarAttendeeSourceFieldProps> = ({ serviceId, options, note, value, disabled = false, onChange }) => {
  const headingId = useId()

  return (
    <div>
      <h6 id={headingId}>Meeting attendees</h6>
      <div className='paragraph-medium zocks-text-gray-600 mb-3'>
        Choose which {getIntegrationDisplayName(serviceId)} field Zocks uses to add clients to your meetings.
      </div>
      <Stack direction='vertical' className='gap-2' role='radiogroup' aria-labelledby={headingId}>
        {options.map((option) => (
          <ScopedBlock key={option.value} missingScopeAction={MissingScopeAction.DISABLE} scope={UPDATE_SCOPE}>
            <Form.Check
              type='radio'
              id={`calendar-attendee-source-${option.value}`}
              name='calendar-attendee-source'
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange(option.value)}
              disabled={disabled}
              label={
                <>
                  <div className='paragraph-medium zocks-text-gray-900'>{option.label}</div>
                  <div className='paragraph-small zocks-text-gray-600'>{option.description}</div>
                </>
              }
            />
          </ScopedBlock>
        ))}
      </Stack>
      {note ? <div className='paragraph-small zocks-text-gray-700 zocks-bg-color-gray-100 rounded-2 px-3 py-2 mt-3'>{note}</div> : null}
    </div>
  )
}
